/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface SearchIntegrationEventsRequest
 */
export interface SearchIntegrationEventsRequest {
    /**
     * 
     */
    search_text: string;
    /**
     * 
     */
    page?: number;
    /**
     * 
     */
    limit?: number;
    /**
     * 
     */
    filter?: SearchIntegrationEventsRequestFilterEnum;
}


/**
 * @export
 */
export const SearchIntegrationEventsRequestFilterEnum = {
    All: 'all',
    Active: 'active',
    Applied: 'applied',
    Notifications: 'notifications',
    Review: 'review',
    Dismissed: 'dismissed',
    Queued: 'queued',
} as const;
export type SearchIntegrationEventsRequestFilterEnum = typeof SearchIntegrationEventsRequestFilterEnum[keyof typeof SearchIntegrationEventsRequestFilterEnum];


/**
 * Check if a given object implements the SearchIntegrationEventsRequest interface.
 */
export function instanceOfSearchIntegrationEventsRequest(value: object): value is SearchIntegrationEventsRequest {
    if (!('search_text' in value) || value['search_text'] === undefined) return false;
    return true;
}

export function SearchIntegrationEventsRequestFromJSON(json: any): SearchIntegrationEventsRequest {
    return SearchIntegrationEventsRequestFromJSONTyped(json, false);
}

export function SearchIntegrationEventsRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchIntegrationEventsRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'search_text': json['search_text'],
        'page': json['page'] == null ? undefined : json['page'],
        'limit': json['limit'] == null ? undefined : json['limit'],
        'filter': json['filter'] == null ? undefined : json['filter'],
    };
}

export function SearchIntegrationEventsRequestToJSON(json: any): SearchIntegrationEventsRequest {
    return SearchIntegrationEventsRequestToJSONTyped(json, false);
}

export function SearchIntegrationEventsRequestToJSONTyped(value?: SearchIntegrationEventsRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'search_text': value['search_text'],
        'page': value['page'],
        'limit': value['limit'],
        'filter': value['filter'],
    };
}

